import {
  string, number, bool, func, node, arrayOf, oneOf, shape,
} from 'prop-types';

const cardType = oneOf([ 'VISA', 'MASTER_CARD', 'AMEX', 'DISCOVER', 'VISAELECTRON', 'MAESTRO', 'UNIONPAY', 'CARTES_BANCAIRES', 'JCB', '' ]);

const amsConfigType = shape({
  sessionId: string.isRequired,
  modulus: string.isRequired,
  exponent: string.isRequired,
  enableCaptcha: bool.enableCaptcha,
});

const newCreditCardFieldsType = shape({
  holderName: string,
  cardNumber: string,
  month: oneOf([ number, string ]),
  year: oneOf([ number, string ]),
  cvv: string,
  captcha: string,
});

const newCreditCardType = {
  availableCardTypes: arrayOf(cardType),
  services: shape({
    createAmsAccount: func.isRequired,
  }).isRequired,
  triggers: shape({
    commitTrigger: func.isRequired,
    validateTrigger: func,
  }).isRequired,
  amsConfig: amsConfigType.isRequired,
  fields: newCreditCardFieldsType,
  isCVVAvailable: bool.isRequired,
  collectCVVConfigs: arrayOf(shape({
    cardType,
    collectCVV: bool,
  })),
  isSavable: bool.isRequired,
  i18n: func.isRequired,
  // isAbleToSavePrimary: bool,
  forceSaveInWallet: bool.isRequired,
  trackingCallback: func,
  displayCVVHelpTextAfterLabel: bool,
  hideCVVHelpText: bool,
};

const savedAccountType = shape({
  accountId: string.isRequired,
  cardType,
  lastFourDigits: string,
  expiryMonth: string,
  expiryYear: string,
  isExpired: bool.isRequired,
  cardHolderName: string,
});

const savedCreditCardFieldsType = shape({
  cvv: string,
});

const savedCartType = {
  services: shape({
    choseSavedAccount: func.isRequired,
  }).isRequired,
  triggers: shape({
    commitTrigger: func.isRequired,
    validateTrigger: func,
  }).isRequired,
  savedAccounts: arrayOf(savedAccountType),
  amsConfig: amsConfigType.isRequired,
  fields: savedCreditCardFieldsType,
  isCVVAvailable: bool.isRequired,
  collectCVVConfigs: arrayOf(shape({
    cardType,
    collectCVV: bool,
  })),
  // isAbleToSavePrimary: bool,
  defaultAccount: string,
  creditCardSwitch: node,
  handleSwitch: func,
  i18n: func.isRequired,
  displayCVVHelpTextAfterLabel: bool,
  hideCVVHelpText: bool,
};

const creditCardType = {
  amsConfig: amsConfigType,
  newCreditCardFields: newCreditCardFieldsType,
  savedCreditCardFields: savedCreditCardFieldsType,
  creditCardPaymentInfo: shape({
    newAccountInfo: shape({
      availableCardTypes: arrayOf(cardType),
      isCVVAvailable: bool.isRequired,
      isSavable: bool.isRequired,
    }),
    savedAccountInfo: shape({
      savedAccounts: arrayOf(savedAccountType),
      isCVVAvailable: bool.isRequired,
      creditCardSwitch: node,
    }),
  }),
  triggers: shape({
    commitTrigger: func.isRequired,
    validateTrigger: func,
  }),
};

export {
  savedCartType,
  newCreditCardType,
  creditCardType,
};
